<template>
  <div class="consumer">
    <div class="text">
      <div class="title">
        <span>{{getIndexData.fixedFieldMap['customer.servingCustomers']}}</span>
      </div>
<!--      <div class="eng">-->
<!--        <span>Serving customers</span>-->
<!--      </div>-->
    </div>
    <div class="pic">
      <div class="item" v-for='(i,k) in showData' :key='k'>
        <div class="imgw">
          <img :src="i.ico" alt="">
        </div>
      </div>
    </div>
    <div class="page">
      <i class="left iconfont icon-youjiantou" @click="prePage()"></i>
      <div class="item" :class="{active: current===k}" v-for='(i,k) in new Array(Math.ceil(total / size))' :key='k'>
        <div @click="currentPage(k)">{{k+1}}</div>
      </div>
      <i class="right iconfont icon-youjiantou" @click="nextPage()"></i>
    </div>
  </div>
</template>


<script>
import {mapGetters} from 'vuex'
  export default {
    props: {
      data: Array,
    },
    data() {
      return {
        showData: [],
        allData: [],
        total: this.data.length,
        size: 4,
        current: 0
      }
    },
    computed: {
      ...mapGetters(['getIndexData']),
    },
    created() {
      this.currentPage(0);
    },
    methods: {
      nextPage() {
        if(this.current+1==Math.ceil(this.total / this.size)){
        }else{
          this.current=this.current+1;
        }
      },
      // 上一页
      prePage() {
        if(this.current==0){
        }else{
          this.current=this.current-1;
        }
      },
      // 点击页码
      currentPage(i) {
        this.current = i;
        this.watch
      }
    },
    watch: {
      data: function (newData, oldData) {
        console.log("order", newData)  //newData就是orderData
        this.total=newData.length;
        this.showData = newData.slice(this.current * this.size, (this.current + 1) * this.size);
      },
      current: function (newData, oldData) {
        console.log("current", newData)  //newData就是orderData
        this.showData = this.data.slice(newData * this.size, (newData + 1) * this.size);
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~styl/mixin.styl"
  .consumer
    fs(0)
    mt(20)

    .text
      ta(center)

      .title
        ta(center)
        fs(0)

        span
          fs(19)

      .eng
        pt(5)
        fs(0)
        c(gray)
        ta(center)

        span
          fs(19)

    .pic
      mt(40)
      min-height 231px
      mb(130)
      overflow hidden

      .item
        oh()
        padding 10%
        float left
        margin 2.4%
        border 0px solid gray
        box-sizing border-box
        ta(center)
        position relative

        .imgw
          position absolute
          top 5%
          bottom 5%
          left 5%
          right 5%

          img
            height 100%
            width 100%
  theme = #f7aa05

  .page
    ta(center)
    fs(0)

    .item
      ib()
      w(40)
      h(30)
      ml(10)
      mr(10)
      va(middle)
      fs(17)
      lh(30)
      c(gray)
      _hover()

      &.active
        bg(theme)
        c(#fff)

    .left
      fs(15)
      c(gray)
      ib()
      transform rotate(180deg)
      vertical-align -4px
      mr(10)

      &:hover
        cursor pointer

    .right
      &:hover
        cursor pointer
      ml(10)
      va(middle)
      c(gray)
      fs(15)

</style>



// WEBPACK FOOTER //
// src/components/consumer/default.vue